import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import Navigation from "./navigation";
import ErrorHandle from "./components/ErrorHandle/ErrorHandle";
import store from "./config/Store"
import { Provider } from "react-redux";
function App() {
  return (
    <>
      <Provider store={store}>
        <ErrorHandle>
          <div className="App">
            <BrowserRouter>
              <Navigation />
              <ToastContainer />
            </BrowserRouter>
          </div>
        </ErrorHandle></Provider>
    </>
  );
}

export default App;
